import React from 'react';
import { Button } from '@rmwc/button';

function JoinReferralButton(props){

	const link_15 = 'https://app.linkmink.com/a/cryptowaves/1725';

  return (
		<>
		   <div className="row mt-3 mb-1">
			 <div className="col-12 justify-content-center align-items-center">
				<Button raised onClick={
						() => { window.open(link_15, "_blank"); }
					}>
						Become an Affiliate & Start Earn
				</Button>
				</div>
				</div>
		{props.showDescription && 
			<div className="mb-1">
				<span className='text-muted small'><a href="/blog/referral">Marketing Materials</a></span>
				<span className="text-muted"> • </span>
				<span className='text-muted small'><a href="/blog/referral-tos">Terms</a></span>
			</div>
		}
	</>
  );
};

JoinReferralButton.defaultProps = {
};

export default JoinReferralButton;